import { createContentfulProps } from "frontend/contentful/lib/create-contentful-props";
import { SearchArchiveTabsEntry } from "frontend/contentful/schema/semantics";
import { createSearchArchiveTabProps } from "../primitives/search-archive-tab.props";
import { useContentful } from "frontend/hooks/use-contentful";
import { TabsProps } from "design-system/components/primitives/tabs/tabs";

export const createSearchArchiveTabsProps = createContentfulProps<
  SearchArchiveTabsEntry,
  TabsProps
>(({ entry }) => {
  const { getEntries } = useContentful();
  const parentTabs: TabsProps = {
    ariaLabel: "Search content tabs",
    tabs: [],
  };

  getEntries(entry.fields.tabs)?.forEach((tab) => {
    const props = createSearchArchiveTabProps(tab);
    if (props) {
      parentTabs.tabs.push(props);
    }
  });

  return parentTabs;
});
